import { cloneDeep } from 'lodash';
const SET_ACCOUNT_CREATION_ERROR = 'SET_ACCOUNT_CREATION_ERROR';
const CLEAR_ACCOUNT_CREATION_ERROR = 'CLEAR_ACCOUNT_CREATION_ERROR';

const initialState = null;

export default function reducer(state = cloneDeep(initialState), action) {
	switch (action.type) {
		case SET_ACCOUNT_CREATION_ERROR:
			return action.payload;
		case CLEAR_ACCOUNT_CREATION_ERROR:
			return null;
		default:
			return state;
	}
}


export function setAccountCreationError(error){
	return {
		type: SET_ACCOUNT_CREATION_ERROR,
		payload: error
	}
};

export function clearAccountCreationError(){
	return { type: CLEAR_ACCOUNT_CREATION_ERROR }
};


// WEBPACK FOOTER //
// ./src/modules/account_creation_error.js